import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'eif-dashboard-card',
	templateUrl: './dashboard-card.component.html',
	styleUrls: ['./dashboard-card.component.scss'],
	standalone: false,
})
export class DashboardCardComponent {
	@Input() public value: number;
	@Input() public subValue?: number;
	@Input() public description: string;
	@Input() public icon: string;
	@Input() public color: string;
	@Input() public loading: boolean = false;
	@Input() public hasAction: boolean = true;
	@Output() public action: EventEmitter<void> = new EventEmitter<void>();

	public hasActionListener(): boolean {
		return this.action.observed && this.hasAction;
	}
}
